var _defs, _g, _path, _path2, _path3, _path4, _polygon;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThrepolyLogoDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 566.1 106.4",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #181e21;\n        stroke-width: 0px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M169,37.3h34v12.3h-34v-12.3ZM177.6,22.9h13.5v57.4l-6-6.4h17.9v12.4h-25.3V22.9h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M213,17.1h13.5v69.1h-13.5V17.1ZM244.3,52c-1.8-1.9-4.2-2.8-7.1-2.8s-4,.4-5.6,1.3c-1.6.9-2.9,2.1-3.7,3.6-.9,1.6-1.3,3.4-1.3,5.4l-6-1.8c.8-4.6,2.1-8.5,4-11.8,1.9-3.2,4.3-5.7,7.2-7.3,2.9-1.7,6.2-2.5,9.7-2.5s7,.8,9.9,2.3,5.1,3.7,6.7,6.6c1.6,2.8,2.4,6.1,2.4,9.8v31.4h-13.5v-26.9c0-3.1-.9-5.5-2.7-7.4h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M272.5,37.3h13.5v49h-13.5v-49ZM284,47.1c1.8-3.4,4.1-6,6.8-7.8,2.7-1.8,5.7-2.7,9-2.7v13.9c-2.9,0-5.5.5-7.5,1.6-2.1,1.1-3.6,2.5-4.7,4.5-1.1,1.9-1.6,4.2-1.6,6.7l-6-4.3c.8-4.5,2.2-8.4,4-11.8h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M317.2,84c-4-2.2-7.2-5.3-9.5-9.2-2.3-3.9-3.5-8.3-3.5-13.1s1.2-9.2,3.5-13.1c2.3-3.9,5.5-7,9.5-9.2s8.5-3.4,13.5-3.4,9.3,1.1,13.3,3.4c4,2.2,7.2,5.3,9.5,9.3s3.5,8.3,3.5,13.2,0,3.2-.3,4.3h-40.6v-9.3h29.8l-2.8,4.8v-.8c0-2.6-.5-4.8-1.6-6.8s-2.6-3.5-4.5-4.6-4-1.6-6.3-1.6-4.5.6-6.4,1.7c-1.9,1.2-3.4,2.8-4.5,4.9-1.1,2.1-1.6,4.5-1.6,7.2s.5,5.2,1.6,7.2c1.1,2.1,2.6,3.7,4.5,4.8,1.9,1.2,4.1,1.7,6.5,1.7s4.6-.5,6.6-1.5,3.3-2.3,4.2-3.8h14.4c-1.7,5.2-4.9,9.3-9.5,12.4s-9.9,4.7-15.9,4.7-9.5-1.1-13.5-3.4v.2h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M366.6,37.3h13.5v67.2h-13.5V37.3ZM384.2,84.1c-3.2-2.2-5.7-5.3-7.5-9.2-1.8-3.9-2.7-8.3-2.7-13.2s.9-9.2,2.7-13.2c1.8-3.9,4.3-7,7.5-9.2s7-3.3,11.2-3.3,8.5,1.1,12.1,3.4c3.6,2.2,6.4,5.3,8.5,9.2s3.1,8.3,3.1,13.1-1,9.2-3.1,13.1-4.9,7-8.5,9.2-7.6,3.4-12.1,3.4-8-1.1-11.2-3.3ZM399,72.7c1.9-1.1,3.4-2.6,4.5-4.5s1.6-4.1,1.6-6.4-.5-4.5-1.6-6.4-2.6-3.4-4.5-4.5-4-1.6-6.3-1.6-4.5.5-6.4,1.6-3.4,2.6-4.5,4.5-1.6,4.1-1.6,6.4.5,4.5,1.6,6.4,2.6,3.4,4.5,4.5,4,1.6,6.3,1.6,4.5-.5,6.4-1.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M439.2,84c-4-2.2-7.2-5.3-9.5-9.2-2.3-3.9-3.5-8.3-3.5-13.1s1.2-9.2,3.5-13.1c2.3-3.9,5.5-7,9.5-9.2s8.5-3.4,13.4-3.4,9.4,1.1,13.4,3.4c4,2.2,7.2,5.3,9.5,9.2s3.4,8.3,3.4,13.1-1.1,9.2-3.4,13.1-5.4,7-9.5,9.2c-4,2.2-8.5,3.4-13.4,3.4s-9.4-1.1-13.4-3.4ZM458.9,72.7c1.9-1.1,3.4-2.6,4.5-4.5s1.6-4.1,1.6-6.4-.5-4.5-1.6-6.4-2.6-3.4-4.5-4.5-4-1.6-6.4-1.6-4.4.5-6.3,1.6-3.4,2.6-4.5,4.5-1.6,4.1-1.6,6.4.5,4.5,1.6,6.4,2.6,3.4,4.5,4.5,4,1.6,6.4,1.6,4.4-.5,6.3-1.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M488.8,17.1h13.5v62.9l-6-6.1h14.1v12.4h-21.6V17.1h0Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M518.2,93.6h13.2l-4.9,3.7,5.3-12.5v4.5l-19.2-46.8,13.8-5.2,14.3,38.7h-4.4l14.3-38.7h15.5l-28.3,69.1h-19.6v-12.7h0Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M0,86.2h63.2v-11.2H0v11.2Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M0,34.2h63.2v-11.2H0v11.2Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M142.4,86.2V23h-11.2v63.2h11.2Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M116.4,86.2V23h-11.2v63.2h11.2Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "79.1 23 79.1 49 0 49 0 60.2 79.1 60.2 79.1 86.2 90.4 86.2 90.4 23 79.1 23"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThrepolyLogoDark);
export default __webpack_public_path__ + "static/media/threpoly-logo-dark.3729a0f312130c016ab278f42382d650.svg";
export { ForwardRef as ReactComponent };